module.exports = __webpack_public_path__ + "static/media/redefining.675caae3.png";